export default __webpack_public_path__ + "static/grab-visitor-attention-924c35ab91ebc756f74cbc188fc0f2b8.svg";